import { Injectable, } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { UserService } from '../shared';

@Injectable()
export class ClientResolver implements Resolve<any> {
  constructor(
    private usersService: UserService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {

    return this.usersService.getclient(route.params['name'])
      .catch((err) => this.router.navigateByUrl('/'));
    

  }
  
}
